<template>
  <div ref="chartdiv" class="InsightCharts InsightCharts--status"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import timeout from '../timeout'

am4core.useTheme(am4themes_animated);

export default {
  name: 'Status',
  mixins: [ timeout ],
  props: {
    dataset: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      chart: null,
      attempts: 0,
      selected: null
    }
  },
  watch: {
    dataset() {
      this.updateData
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  mounted() {
    let container = am4core.create(this.$refs.chartdiv, am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);
    container.layout = "horizontal";


    let chart = container.createChild(am4charts.PieChart);
    chart.radius = am4core.percent(60);

    
    this.chart = chart;

    // Add data
    chart.data = this.generateChartData();

    
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "count";
    pieSeries.dataFields.category = "label";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.slices.template.propertyFields.isActive = "pulled";
    pieSeries.slices.template.strokeWidth = 0;

    pieSeries.slices.template.events.on("hit", this.onHit);

    pieSeries.labels.template.maxWidth = 130;
    pieSeries.labels.template.wrap = true;
    pieSeries.alignLabels = false;

  },
  methods: {
    updateData() {
      if (this.chart) {
        this.chart.data = this.generateChartData()
        this.chart.invalidateData()
        this.attempts = 0
      } else if (this.attempts < 10) {
        this.attempts = this.attempts + 1
        this.setTimeout(this.updateData)
      }
    },
    onHit(event) {
      if (event.target.dataItem.dataContext.id != this.selected) {
        this.$emit('filter', { ids: this.dataset[event.target.dataItem.dataContext.id].projects })
        this.selected = event.target.dataItem.dataContext.id
      } else {
        this.$emit('filter', { ids: null })
        this.selected = null
      }
    },
    generateChartData() {
      let dataset = this.dataset.map((data, index) => Object.assign(data, { color: this.chart.colors.getIndex(index)}));

      let chartData = [];
      for (let i = 0; i < dataset.length; i++) {
        // if (i == this.selected) {
        //   for (let x = 0; x < dataset[i].subData.length; x++) {
        //     if (dataset[i].subData[x].count !== 0) {
        //       chartData.push({
        //         label: dataset[i].subData[x].label,
        //         count: dataset[i].subData[x].count,
        //         color: dataset[i].color,
        //         pulled: true
        //       });
        //     }
        //   }
        // } else {
          chartData.push({
            label: dataset[i].label,
            count: dataset[i].count,
            color: dataset[i].color,
            id: i
          });
        //}
      }

      return chartData;
    }
  },
  
}
</script>